// src/services/inventoryService.js
import { getCurrentUser } from '../utils/auth';
import { DEFAULT_WIG_VALUES } from '../constants/wigOptions';
import { apiService } from './apiService';

export const inventoryService = {
  async addInventoryItem(wigData) {
    const currentUser = getCurrentUser();

    const itemWithDefaults = {
      ...DEFAULT_WIG_VALUES,
      Wig_Bar_Code: wigData.barcode || wigData.Wig_Bar_Code,
      Wig_Serial_Code: wigData.serialCode || wigData.Wig_Serial_Code || wigData.barcode,
      CutByStyle: wigData.cutStyle || wigData.CutByStyle,
      Base_Color: wigData.baseColor || wigData.Base_Color,
      Wig_Type: wigData.wigType || wigData.Wig_Type,
      Top_Size: wigData.topSize || wigData.Top_Size,
      Wig_Length: wigData.hairLength || wigData.Wig_Length,
      Custom_Comments: wigData.comments || wigData.Custom_Comments || '',
      AddedBy: currentUser,
      ...(wigData.netSize && { Net_Size: wigData.netSize }),
      ...(wigData.hairType && { Hair_Type: wigData.hairType }),
      ...(wigData.netType && { Net_Type: wigData.netType }),
      ...(wigData.laceType && { Lace_Type: wigData.laceType }),
      ...(wigData.inventoryType && { InventoryType: wigData.inventoryType }),
      ...(wigData.InvStatus && { InvStatus: wigData.InvStatus })
    };

    return await apiService.post('/api/inventory/add', itemWithDefaults);
  },

  async updateInventoryItem(barcode, field, value, source) {
    const endpoint = source === '2025' 
      ? `/api/inventory/update-2025/${barcode}` 
      : `/api/inventory/update-main/${barcode}`;
    
    return await apiService.put(endpoint, { field, value });
  },

  async updateBarcode(oldBarcode, newBarcode, orderNo) {
    return await apiService.put(`/api/inventory/update-barcode/${oldBarcode}`, {
      newBarcode,
      orderNo: orderNo || null
    });
  },


// For year counts - get stats for ALL years with breakdown
// For year counts
async getYearStats() {
  const response = await apiService.get('/api/inventory/inventory-stats?includeYears=true');
  return response;
},

// For status counts  
async getStats(year = 'all') {
  try {
    let url = '/api/inventory/inventory-stats';
    if (year !== 'all') {
      url += `?year=${year}`;
    }
    console.log(`getStats() - calling: ${url}`);
    const response = await apiService.get(url);
    console.log('getStats() response:', response);
    
    if (!response.success) {
      throw new Error(response.message || 'Failed to fetch statistics');
    }

    return response;
  } catch (error) {
    console.error('Error in getStats:', error);
    throw error;
  }
},

// In inventoryService.js
async getInventoryStatus(page, limit, status, year = 'all', advancedFilters = {}) {
  const statusParam = status !== 'all' ? `&status=${status}` : '';
  const yearParam = year !== 'all' ? `&year=${year}` : '';
  
  // Build advanced filter parameters
  let advancedParams = '';
  Object.entries(advancedFilters).forEach(([key, value]) => {
    if (value && value !== 'all') {
      advancedParams += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  
  return await apiService.get(`/api/inventory/inventory-status?page=${page}&limit=${limit}${statusParam}${yearParam}${advancedParams}`);
},


  // Update existing searchInventory to support year filtering
  async searchInventory(query, status = 'all', year = 'all') {
    const statusParam = status !== 'all' ? `&status=${status}` : '';
    const yearParam = year !== 'all' ? `&year=${year}` : '';
    return await apiService.get(`/api/inventory/search?query=${encodeURIComponent(query)}${statusParam}${yearParam}`);
  },

  async deleteInventoryItem(barcode, source) {
      return await apiService.delete(`/api/inventory/${source}/${barcode}`);
  },

  // Bulk warehouse update - transfer items from one warehouse to another
  // includeOrderNos: list of order numbers TO MOVE (like bulk auto-complete)
  async bulkWarehouseUpdate(fromWarehouse, toWarehouse, includeOrderNos, dryRun = true) {
    return await apiService.post('/api/inventory/bulk-warehouse-update', {
      fromWarehouse,
      toWarehouse,
      includeOrderNos,
      dryRun
    });
  }

};